import { useEffect, useState } from 'react';
import axios from 'axios';
import { Crop, ImagePlus, RefreshCw } from 'lucide-react';
import { Vignette } from '../livret-base/ChoixPhotosDialog';

const cache = {};
// URL (blob) d'une photo d'emplacement : « defaut:cle » = photo d'origine du centre, sinon photo de la bibliothèque
export const useUrlPhoto = (ref) => {
  const [url, setUrl] = useState(cache[ref]);
  useEffect(() => {
    if (!ref) return;
    if (cache[ref]) { setUrl(cache[ref]); return; }
    const chemin = ref.startsWith('defaut:') ? `/presentation-centre/photo-defaut/${ref.slice(7)}` : `/livret-base/photos/${ref}`;
    axios.get(chemin, { responseType: 'blob' }).then((r) => { cache[ref] = URL.createObjectURL(r.data); setUrl(cache[ref]); }).catch(() => {});
  }, [ref]);
  return url;
};

const VignetteRef = ({ refPhoto }) => {
  const url = useUrlPhoto(refPhoto?.startsWith('defaut:') ? refPhoto : null);
  if (!refPhoto?.startsWith('defaut:')) return <Vignette id={refPhoto} className="h-16 w-24 rounded-md" />;
  return url ? <img src={url} alt="" className="h-16 w-24 rounded-md object-cover" /> : <div className="h-16 w-24 animate-pulse rounded-md bg-slate-200" />;
};

// Emplacements photo d'une diapo : chaque photo se change et se recadre une par une
export const PhotosEmplacements = ({ d, refs, cadrages, edition, onChanger, onRecadrer, onToutes }) => (
  <div className="mb-3 flex flex-wrap items-end gap-3" data-testid={`presentation-emplacements-${d.cle}`}>
    {Array.from({ length: d.nb_photos }).map((_, i) => (
      <div key={i} className="flex flex-col items-center gap-1">
        {refs[i] ? <div className="relative"><VignetteRef refPhoto={refs[i]} />
          {cadrages[i] && <span className="absolute right-1 top-1 rounded bg-[#8DC63F] px-1 text-[9px] font-bold text-white">recadrée</span>}</div>
          : <div className="flex h-16 w-24 items-center justify-center rounded-md border border-dashed border-slate-300 text-[10px] text-slate-400">vide</div>}
        {edition && (
          <div className="flex gap-2 text-[11px]">
            <button type="button" onClick={() => onChanger(i)} data-testid={`presentation-photo-changer-${d.cle}-${i}`}
              className="inline-flex items-center gap-0.5 text-slate-500 hover:text-[#0F172A]"><ImagePlus className="h-3 w-3" /> {refs[i] ? 'Changer' : 'Ajouter'}</button>
            {refs[i] && <button type="button" onClick={() => onRecadrer(i)} data-testid={`presentation-photo-recadrer-${d.cle}-${i}`}
              className="inline-flex items-center gap-0.5 text-slate-500 hover:text-[#0F172A]"><Crop className="h-3 w-3" /> Recadrer</button>}
          </div>
        )}
      </div>
    ))}
    {edition && d.nb_photos > 1 && (
      <button type="button" onClick={onToutes} data-testid={`presentation-photos-${d.cle}`}
        className="mb-5 inline-flex items-center gap-1 text-xs text-slate-500 hover:text-[#0F172A]"><RefreshCw className="h-3.5 w-3.5" /> Choisir toutes les photos</button>
    )}
  </div>
);
